export default "__VITE_ASSET__DYak68mH__"